module.exports = __webpack_public_path__ + "img/unsubscribe.61305f74.jpeg";